export function HeaderSmallIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M6 5a1 1 0 00-2 0v14a1 1 0 102 0v-6h4v6a1 1 0 102 0V5a1 1 0 10-2 0v6H6V5zm11 7a1 1 0 100 2h.003a3 3 0 11-2.559 4.572 1 1 0 111.703-1.05A.999.999 0 0018 17a1 1 0 00-1-1h-.003a3 3 0 111.988-5.25 1 1 0 11-1.324 1.5A.993.993 0 0017 12z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
